/*
  NDI Contact page — success/error message modal + GTM dataLayer push.
  Ported from the old theme's inline page.contact script. Vanilla JS, deferred.
*/
(function () {
  function init() {
    var contactForm = document.getElementById('ContactForm');
    var messageModal = document.getElementById('contact-message-modal');
    var closeMessageBtn = document.getElementById('close-contact-message');

    if (!contactForm || !messageModal || !closeMessageBtn) return;

    function showMessage(type, title, text) {
      var messageIcon = document.getElementById('contact-message-icon');
      var messageTitle = document.getElementById('contact-message-title');
      var messageText = document.getElementById('contact-message-text');
      var messageCloseBtn = document.getElementById('close-contact-message');

      messageIcon.className = 'message-icon';
      messageTitle.className = 'message-title';
      messageCloseBtn.className = 'message-close-btn';

      messageIcon.classList.add(type);
      messageTitle.classList.add(type);
      messageCloseBtn.classList.add(type);

      messageTitle.textContent = title;
      messageText.textContent = text;

      messageModal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeMessage() {
      messageModal.hidden = true;
      document.body.style.overflow = '';
    }

    closeMessageBtn.addEventListener('click', closeMessage);
    messageModal.addEventListener('click', function (e) {
      if (e.target === messageModal) closeMessage();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !messageModal.hidden) closeMessage();
    });

    // NDI: UNFINISHED — GTM event pending analytics consolidation review. This pushes
    // contact_submit to dataLayer, but GTM is not loaded yet (container/home TBD after the
    // analytics audit, see docs/analytics-firing-map.md). Revisit event name + PII (email)
    // + whether it fires here or via a Customer-events pixel before go-live.
    contactForm.addEventListener('submit', function () {
      // Marks the round-trip as OURS — the quote modal also posts to /contact from this
      // page, and Shopify flags both forms as posted (see the note below).
      sessionStorage.setItem('ndiContactSubmitted', '1');

      var emailField = contactForm.querySelector('input[name="contact[email]"]');
      var email = emailField ? emailField.value : null;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'contact_submit', email: email });
    });

    // Show the modal after a submit round-trip (Liquid renders the flag elements).
    var successMessage = contactForm.querySelector('.contact-success');
    var errorMessage = contactForm.querySelector('.contact-error');

    // ⚠️ Shopify marks EVERY {% form 'contact' %} on the page as posted, and the quote
    // modal renders here too — so `.contact-success` existing means only that SOME contact
    // form posted. Without this flag, sending a quote from this page also popped
    // "Message Sent!". Consumed on read, which also stops a refresh from re-showing it.
    var submitted = sessionStorage.getItem('ndiContactSubmitted');
    if (submitted) sessionStorage.removeItem('ndiContactSubmitted');

    if (submitted && successMessage) {
      setTimeout(function () {
        showMessage('success', 'Message Sent!', "Thanks! We've received your message and will get back to you soon.");
        contactForm.reset();
      }, 300);
    } else if (submitted && errorMessage) {
      setTimeout(function () {
        showMessage('error', 'Submission Error', 'Please check the highlighted fields and try again.');
      }, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
